import React from 'react'

const Unauthorized = () => {
  return (
    <div className="unauthorized-container mt-0">
      <div className="d-flex flex-column align-items-center justify-content-center" style={{height: '80vh'}}>
        <div className='bg-white p-5 rounded-3 shadow-xl'>
          <h1>403 - Unauthorized Access</h1>
          <p>Sorry, you don't have permission to view this page.</p>
        </div>
      </div>
    </div>
  )
}

export default Unauthorized